export const storage = {
  set(key, value, expiration = null) {
    const item = {
      value: value,
      expiration: expiration ? new Date().getTime() + expiration : null,
    };
    // const consentCookie = this.get('cc_cookie');
    // const consentCookieServices = consentCookie?.services?.functional;
    // const isFunctional = !consentCookie || (consentCookieServices && consentCookieServices.includes(key));

    // if (isFunctional) {
    localStorage.setItem(key, JSON.stringify(item));
    // }
  },

  get(key) {
    const item = JSON.parse(localStorage.getItem(key));
    if (!item) return null;

    if (item.expiration && new Date().getTime() > item.expiration) {
      localStorage.removeItem(key);
      return null;
    }

    return item.value || item;
  },

  remove(key) {
    localStorage.removeItem(key);
  },

  clear() {
    localStorage.clear();
  },
};
